import { render, staticRenderFns } from "./LinhaDeRecebimentosDetalhes.vue?vue&type=template&id=20e73f4d&scoped=true"
import script from "./LinhaDeRecebimentosDetalhes.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeRecebimentosDetalhes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeRecebimentosDetalhes.vue?vue&type=style&index=0&id=20e73f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e73f4d",
  null
  
)

export default component.exports